// removed by extract-text-webpack-plugin
module.exports = {"IndexAchieverIndex":"IAIndex__IndexAchieverIndex__ou7M3","title":"IAIndex__title__22Eql","IndexAchieverAllocations":"IAIndex__IndexAchieverAllocations__YRNCY","IndexAchieverAssetsGroup":"IAIndex__IndexAchieverAssetsGroup__1U4Jn","IndexAchieverTitles":"IAIndex__IndexAchieverTitles__3aa32","IndexAchieverAssets":"IAIndex__IndexAchieverAssets__2OJUo","totalWrong":"IAIndex__totalWrong__16rb6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/IAIndex/IAIndex.css
// module id = 532
// module chunks = 0